import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { listContentVariants } from "./actions";

export const contentVariantEntityAdapter = createEntityAdapter({
  selectId: (entity) => entity?.variant?.id,
});

const initialState = contentVariantEntityAdapter.getInitialState({
  totalItems: 0,
  processingContentVariantIds: [],
  failedCount: 0,
  completedCount: 0,
});

export const contentVariantSlice = createSlice({
  name: "contentVariant",
  initialState: initialState,
  reducers: {
    addProcessingContentVariantIds: (state, action) => {
      state.processingContentVariantIds.push(...action.payload);
    },
    removeProcessingContentVariantId: (state, action) => {
      state.processingContentVariantIds = state.processingContentVariantIds.filter((id) => id !== action.payload);
    },
    incrementFailedCount: (state) => {
      state.failedCount += 1;
    },
    decrementFailedCount: (state) => {
      state.failedCount -= 1;
    },
    incrementCompletedCount: (state) => {
      state.completedCount += 1;
    },
    decrementCompletedCount: (state) => {
      state.completedCount -= 1;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(listContentVariants.fulfilled, (state, action) => {
      if (action.payload?.statusCode === 200) {
        if (action.meta?.arg?.replace) {
          // remove all existing variants with same language and contentId and replace with new ones
          const contentIdToLanguageMap = action.payload?.data?.items?.reduce((acc, item) => {
            if (item.variant.type === "subtitle") acc[item?.variant?.contentId] = item?.subtitles?.[0]?.language;
            else acc[item?.variant?.contentId] = item?.variant?.language;

            return acc;
          }, {});

          const variantsWithSameLanguageAndContentId = Object.values(state.entities)
            .filter((variant) => contentIdToLanguageMap[variant?.variant?.contentId] === variant?.variant?.language)
            .map((variant) => variant?.variant?.id);

          contentVariantEntityAdapter.removeMany(state, variantsWithSameLanguageAndContentId);
        }
        if (action.meta.arg.isInsertEntities) {
          contentVariantEntityAdapter.setAll(state, action.payload.data.items);
        } else {
          contentVariantEntityAdapter.upsertMany(state, action.payload.data.items);
        }
        state.totalItems = action.payload.data.totalItems;
      }
    });
  },
});

export const {
  addProcessingContentVariantIds,
  removeProcessingContentVariantId,
  incrementCompletedCount,
  decrementCompletedCount,
  incrementFailedCount,
  decrementFailedCount,
} = contentVariantSlice.actions;

export default contentVariantSlice.reducer;
